interface Props {
  fill?: string;
  height?: number;
}

// SVG path data for the Ascente wordmark
const LOGO_PATH =
  "M12.5 2L2 22h4.5l2-4.5h8l2 4.5H23L12.5 2zm0 6l3 6.5H9.5L12.5 8z";

export function AscenteLogo({ fill = "#1a1a2e", height = 26 }: Props) {
  const aspectRatio = 4.2;
  return (
    <svg
      height={height}
      width={height * aspectRatio}
      viewBox="0 0 110 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Ascente"
    >
      <path d={LOGO_PATH} fill={fill} />
      <text
        x="28"
        y="19"
        fontFamily="DM Sans, sans-serif"
        fontWeight="700"
        fontSize="18"
        fill={fill}
        letterSpacing="-0.5"
      >
        Ascente
      </text>
    </svg>
  );
}
